<template>
  <v-dialog v-model="dialog" max-width="600px">
    <BaseBodyDialog title="Chỉnh sửa tiêu chí đánh giá" @close="closeDialog" @save="saveCriteria">
      <v-form class="mt-6" ref="form" v-model="valid">
        <v-text-field
          v-model="editedCriteria.title"
          label="Tiêu đề"
          required
          :rules="[(v) => !!v || 'Tiêu đề là bắt buộc']"
          outlined
          dense
        ></v-text-field>

        <v-switch v-model="editedCriteria.isRequired" label="Bắt buộc" color="primary"></v-switch>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  components: {
    BaseBodyDialog,
  },
  data() {
    return {
      dialog: false,
      valid: false,
      editedCriteria: {
        id: null,
        title: '',
        isRequired: false,
      },
    }
  },
  methods: {
    ...mapActions('evaluateCriteria', ['updateEvaluateCriteria']),
    open(criteria) {
      this.editedCriteria = {
        id: criteria.id,
        title: criteria.title,
        isRequired: criteria.isRequired,
      }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.$refs.form.reset()
    },
    async saveCriteria() {
      if (this.$refs.form.validate()) {
        try {
          await this.updateEvaluateCriteria({
            id: this.editedCriteria.id,
            data: {
              title: this.editedCriteria.title,
              isRequired: this.editedCriteria.isRequired,
            },
          })
          this.$emit('criteriaUpdated')
          this.closeDialog()
        } catch (error) {
          console.error('Error updating criteria:', error)
        }
      }
    },
  },
}
</script>
